import { Component, inject, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GaEventService } from '../../../../core/services/ga.service';
import {
  PARENT_ANALYTICS_LAYOUT,
  ParentAnalyticsEvents,
} from '../../../../core/analytics/parent-analytics.events';

export type ProfileTabId = 'general' | 'settings' | 'subscriptions';

@Component({
  selector: 'app-profile-toolbar',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './profile-toolbar.component.html',
  styleUrl: './profile-toolbar.component.scss',
})
export class ProfileToolbarComponent {
  #analytics = inject(GaEventService);

  selectedTab = input.required<ProfileTabId>();
  /** Family-parent profile only — school/admin hide billing. */
  showSubscriptions = input(false);
  tabChange = output<ProfileTabId>();

  selectTab(tab: ProfileTabId): void {
    this.#analytics.sendEvent(ParentAnalyticsEvents.CLICK_TAB, {
      layout: PARENT_ANALYTICS_LAYOUT,
      tab_name: tab,
      source: 'profile_toolbar',
    });
    this.tabChange.emit(tab);
  }
}
